import React from 'react';
import { Stack, Badge } from '@moda/om';
import { SizeInventoryFragment } from '../../generated/types';
import { SizeGuideLink, hasSizeEquivalents } from '../SizeGuide';
import { SizeSelectorList } from './SizeSelectorList';
import './MobileSelectSizeView.scss';

type Props = {
  fitRecommendation?: string | null;
  sizes: SizeInventoryFragment[];
  sizeEquivalents: string[][];
  selectedSize: SizeInventoryFragment | null;
  onSelect: (size: SizeInventoryFragment) => void;
};

export const MobileSelectSizeView: React.FC<Props> = ({
  fitRecommendation,
  sizes,
  sizeEquivalents,
  selectedSize,
  onSelect
}) => (
  <Stack space={4}>
    {fitRecommendation && <Badge theme="noise">{fitRecommendation}</Badge>}
    <SizeSelectorList
      sizes={sizes}
      sizeEquivalents={sizeEquivalents}
      selectedSize={selectedSize}
      onSelect={onSelect}
    />
    {hasSizeEquivalents(sizeEquivalents) && (
      <div className="MobileSelectSizeView__footer">
        <SizeGuideLink
          sizes={sizes}
          sizeEquivalents={sizeEquivalents}
          fitRecommendation={fitRecommendation}
        />
      </div>
    )}
  </Stack>
);
